import { LocalStorageKeys } from "@/services/storage.service";

// Ensure app doesn't refresh
export function preventAppRefresh() {
  // Ensure app doesn't refresh
  localStorage.setItem(LocalStorageKeys.PreventRefresh, "1");
}

export function allowAppRefresh() {
  // Remove the field from localStorage to allow app to refresh
  localStorage.removeItem(LocalStorageKeys.PreventRefresh);
}
